import React from 'react'
import Navbar from '../components/Navbar'
import data from '../data/onion.json'
import ProductCard from '../components/ProductCard'
import Footer from '../components/Footer'

const Onion = () => {
    return (
        <>
            <Navbar />
            <section className="mrg_tb">
                <div className="container">

                    <div className="heading d-flex flex-column justify-content-center align-items-center mb-4">
                        <h2 className="Viga text-center  wow animate__flash" data-wow-duration="1s">Onion Products
                        <span className="cl-theme"></span></h2>
                    </div>

                    <div className="row">
                        {
                            data?.map(item => {
                                return <ProductCard data={item} type="onion" />
                            })
                        }
                    </div>
                </div>
            </section>
            <Footer></Footer>
        </>
    )
}

export default Onion